import { CopyIcon } from '@chakra-ui/icons'
import { Box, } from '@chakra-ui/react'
import ForceGraphs from './ForceGraph'


const ShowContent = ({balance,symbol}:{balance:any,symbol:any}) => {

  return (
    
<Box height={["300px","300px","400px"]} width={["100%","100%","40%"]} border="1px solid #dee5ed10" borderRadius="8px">
  
        <ForceGraphs /> 
     
  </Box>
  )
}

export default ShowContent